import {
  AnimationEvent,
  transition,
  trigger,
  useAnimation,
} from '@angular/animations';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  fadeInFromLeftAnimation,
  fadeOutToLeftAnimation,
} from '../../../../shared/animations/index';
import { AppNavigationService } from '../../services/app-navigation.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  animations: [
    trigger('fadeInFromLeftOutToLeftAnimation', [
      transition('void => visible', [
        useAnimation(fadeInFromLeftAnimation, {
          params: {
            duration: '0.15s',
            delay: '0s',
          },
        }),
      ]),
      transition('hidden => visible', [
        useAnimation(fadeInFromLeftAnimation, {
          params: {
            duration: '0.15s',
            delay: '0s',
          },
        }),
      ]),
      transition('visible => hidden', [
        useAnimation(fadeOutToLeftAnimation, {
          params: {
            duration: '0.15s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class AppHeaderComponent implements OnDestroy, OnInit {
  private readonly _appNavigationService = inject(AppNavigationService);

  private subscriptions: Subscription = new Subscription();

  appHeaderVisible: boolean;
  accommodateAppSidebar: boolean;
  appViewTitle: string;
  appViewTitleAnimationState: string = 'void';
  displayedAppViewTitle: string;

  ngOnInit(): void {
    this.subscriptions.add(
      this._appNavigationService.showAppHeader$.subscribe((value: boolean) => {
        this.appHeaderVisible = value;
      }),
    );

    this.subscriptions.add(
      this._appNavigationService.showAppSidebar$.subscribe((value: boolean) => {
        this.accommodateAppSidebar = value;
      }),
    );

    this.subscriptions.add(
      this._appNavigationService.appViewTitle$.subscribe((title: string) => {
        this.appViewTitle = title;
        if (this.appViewTitleAnimationState === 'void' && title !== null) {
          this.displayedAppViewTitle = title;
          this.appViewTitleAnimationState = 'visible';
        } else if (this.appViewTitleAnimationState === 'visible') {
          this.appViewTitleAnimationState = 'hidden';
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  appViewTitleAnimationDone(event: AnimationEvent): void {
    if (event.fromState === 'void' && event.toState === 'visible') {
      this.displayedAppViewTitle = this.appViewTitle;
    } else if (event.fromState === 'visible' && event.toState === 'hidden') {
      this.displayedAppViewTitle = this.appViewTitle;
      this.appViewTitleAnimationState = 'visible';
    }
  }
}
